module.exports = __webpack_public_path__ + "img/banned_status.01f5f53b.svg";